import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

import { AuthService } from '../../../services/auth.service'

@Component({
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: true,
    imports: [CommonModule]
})
export class LoginComponent implements OnInit {
  redirectTo: string

  constructor(
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.redirectTo = this.activatedRoute.snapshot.queryParams?.redirectTo
  }

  loginWithKeycloak(): void {
    // Build the redirect URL including the redirectTo parameter if it exists
    const baseUrl = window.location.origin
    const targetPath = this.redirectTo || '/'
    const redirectUri = `${baseUrl}/${targetPath.startsWith('/') ? targetPath.slice(1) : targetPath}`

    this.authService.loginWithKeycloak(redirectUri)
  }
}
